export default "__VITE_ASSET__L_bc7PE$__"